<template>
  <div id="app">
    <div class="app-main-container" v-if="isMobile">
      <!-- 置顶 -->
      <el-backtop :visibility-height="100">
        <div class="app-gotop-box">
          <div class="top">
            <i class="icon iconfont icon-zhiding"></i>
          </div>
        </div>
      </el-backtop>
      <!-- mobile端顶部 -->
      <appHeader v-show="appHeaderShow"></appHeader>
      <!-- mobile端主内容区 -->
      <div class="app-main-view">
        <router-view />
      </div>
      <!-- mobile端底部 -->
      <appFooter v-show="appFooterShow"></appFooter>
    </div>
    <div class="pc-main-container" v-else>
      <!-- 置顶 -->
      <el-backtop :visibility-height="100" :bottom="100">
        <div class="pc-gotop-box">
          <div class="top mq-wh100">
            <i class="icon iconfont icon-zhiding" style=""></i>
            <p>置顶</p>
          </div>
        </div>
      </el-backtop>
      <!-- pc端顶部 -->
      <pcHeader v-show="pcHeaderShow"></pcHeader>
      <!-- pc端主内容区 -->
      <div class="pc-main-view">
        <router-view />
      </div>
      <!-- pc端底部 -->
      <pcFooter></pcFooter>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      // isMobile: false, // 是否为移动端
      pcHeaderShow: true, // pc端头部显示控制
      appHeaderShow: true, // mobile端头部显示控制
      isColumn: false, // 是否获取到栏目
      appFooterShow: true, // mobile底部显示控制
    };
  },
  computed: {
    // 是否为移动端判断
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  created() {
    // window.localStorage.setItem('token', "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvYXBpLm12Y3NreS5jb21cL2FwaVwvdXNlcnNcL3B3ZGxvZ2luIiwiaWF0IjoxNjE0OTM3Njc2LCJleHAiOjE2MTUxNTM2NzYsIm5iZiI6MTYxNDkzNzY3NiwianRpIjoiZWdzVVV2a3ZpVGZvUUt3dSIsInN1YiI6MTIsInBydiI6ImY2NGQ0OGE2Y2VjN2JkZmE3ZmJmODk5NDU0YjQ4OGIzZTQ2MjUyMGEifQ.CO4BfHFKlPvAhK64I0zVAu7L37yHR_hnMyfPuge-p28");
    // window.localStorage.setItem('token', '');
    this.openBus();
  },
  mounted() {
    this.getEquipment();
  },
  methods: {
    /**
     * @function openBus 开启监听
     */
    openBus() {
      this.$bus.$on("pcHeaderShow", (res) => {
        this.pcHeaderShow = res;
      });
      this.$bus.$on('appFooterSHow', (res) => {
        this.appFooterShow = res;
      });
    },
    /**
     * @function getEquipment 获取设备信息是否为移动端
     */
    getEquipment() {
      if (this.isMobile) {
        this.setRemSize();
      }
    },
    /**
     * @function setRemSize 设置rem比例
     */
    setRemSize() {
      // 设计稿宽度414px
      let w = 414;
      // 根元素fontsize尺寸
      let html = document.documentElement;
      // let size = window.getComputedStyle(html).fontSize;
      // 获取屏幕宽度
      let scrWidth = document.documentElement.clientWidth;
      let rem = 100;
      // (当前设备屏幕宽度 / 设计稿宽度) * 当前1rem的取值
      html.style.fontSize = (scrWidth / w) * rem + "px";
      let dpr = window.devicePixelRatio;
      html.setAttribute("data-dpr", dpr);
      html = null;
    },
  },
};
</script>

<style lang="scss">
#app {
  position: relative;
  width: 100%;
  // height: 100%;
  font-family: PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  letter-spacing: 0.7px;
  -webkit-font-smoothing: antialiased;
  -webkit-appearance: none;
  -moz-osx-font-smoothing: grayscale;
  // background: #F4F7F9;
  overflow: auto;
  .pc-main-view {
    min-height: 600px;
  }
  .top178 {
    padding-top: 178px;
  }
  .app-main-view {
    min-height: 600px;
    padding-top: 0.48rem;
  }
}
.el-backtop {
  width: 0 !important;
  height: 0 !important;
}
.pc-gotop-box {
  position: fixed;
  bottom: 100px;
  right: 50px;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 0px 6px rgba(156, 169, 195, 0.48);
  .top {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    i {
      font-size: 16px;
      color: #4d5c7a;
    }
    p {
      font-size: 14px;
      color: #4d5c7a;
    }
  }
}
.app-gotop-box {
  position: fixed;
  bottom: 1rem;
  right: 0.1rem;
  width: 0.45rem;
  height: 0.45rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 0.06rem rgba(136, 147, 165, 0.48);
  text-align: center;
  overflow: hidden;
  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    line-height: 0.45rem;
    i {
      color: #8893a5;
    }
  }
}
.app-product-list {
  width: 100%;
  border-top: 0.01rem solid #eee;
  .list-item {
    display: flex;
    width: calc(100% - 0.4rem);
    padding: 0.2rem;
    border-bottom: 0.01rem solid #eee;
    .img-box {
      display: flex;
      width: 0.6rem;
      height: 0.6rem;
      overflow: hidden;
      img {
        width: 100%;
        margin: auto;
      }
    }
    .info-box {
      width: calc(100% - 0.8rem);
      margin-left: 0.2rem;
      p {
        margin-bottom: 0.06rem;
      }
      .item-title {
        font-size: 16px;
        color: #202344;
      }
      .item-info {
        font-size: 0.13rem;
        font-family: PingFang SC;
        color: #8893a5;
        line-height: 0.17rem;
      }
      .company {
        font-size: 0.13rem;
        font-family: PingFang SC;
        color: #202344;
      }
      .price {
        font-size: 0.12rem;
        font-family: PingFang SC;
        color: #8893a5;
        span {
          font-size: 0.16rem;
          color: #ff6c0d;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue